if (!customElements.get('product-subscription')) {
	customElements.define(
		'product-subscription',
		class ProductSubscriptions extends HTMLElement {
			constructor() {
				super();
				this.addSubscriptionButton = this.querySelector('[data-subscription-add-to-cart]');
				this.addToCartButton = this.querySelector('[data-add-to-cart]');
				this.options = this.querySelectorAll('[data-subsctiption-option]');
				this.optionsWrapper = this.querySelectorAll('[data-option-wrappper]');
				this.optionButtons = this.querySelectorAll('[data-option-selector]');
				this.sellingPlanTrigger = this.querySelector('[data-selling-plan-select-trigger]');
				this.sellingPlansWrapper = this.querySelector('[data-plans-wrapper]');
				this.sellingPlanButtons = this.querySelectorAll('[data-plan-trigger]');
				this.increaseQuantityButtons = this.querySelectorAll('[data-increase]');
				this.decreaseQuantityButtons = this.querySelectorAll('[data-decrease]');
				this.quantityInputs = this.querySelectorAll('[data-quantity-input]');
			}

			get variantID() {
				return this.dataset.id;
			}
			get planID() {
				return this.dataset.planId;
			}

			get productQuantity() {
				return this.dataset.quantity;
			}

			connectedCallback() {
				this.setEventListeners();
			}

			setEventListeners() {
				if (!this.addSubscriptionButton) return;
				this.addSubscriptionButton.addEventListener('click', () =>
					this.addToCart(this.planID, true),
				);

				if (!this.addToCartButton) return;
				this.addToCartButton.addEventListener('click', () => this.addToCart());

				if (this.optionButtons.length == 0) return;
				this.optionButtons.forEach((button) => {
					button.addEventListener('click', () => this.setOption(button));
				});

				if (!this.sellingPlanButtons.length === 0) return;
				this.sellingPlanButtons.forEach((button) => {
					button.addEventListener('click', () => this.setSellingPlan(button));
				});

				if (!this.increaseQuantityButtons.length === 0) return;
				this.increaseQuantityButtons.forEach((button) =>
					button.addEventListener('click', () => this.increaseQuantity()),
				);

				if (!this.decreaseQuantityButtons.length === 0) return;
				this.decreaseQuantityButtons.forEach((button) =>
					button.addEventListener('click', () => this.decreaseQuantity()),
				);

				if (!this.quantityInputs.length === 0) return;
				this.quantityInputs.forEach((input) =>
					input.addEventListener('change', (event) => this.changeQuantity(event)),
				);

				if (!this.sellingPlanTrigger) return;
				this.sellingPlanTrigger.addEventListener('click', () => this.toggleSellingPlans());
				document.addEventListener('click', (event) => {
					const sunscriptionOption = this.querySelector('[data-option-wrappper="subscription"]');
					if (!sunscriptionOption.contains(event.target)) {
						if (this.sellingPlansWrapper.classList.contains('mandatory')) return;
						this.sellingPlansWrapper.classList.remove('active');
					}
				});
			}

			async addToCart(selling_plan, addWithSellingPlan) {
				const url = `${window.routes.cartAdd}.js`;
				const product_data = {
					items: [
						{
							id: this.variantID,
							quantity: this.productQuantity,
						},
					],
					sections: 'cart-main,cart-drawer-sections',
				};
				if (addWithSellingPlan) {
					if (selling_plan) {
						product_data.items[0].selling_plan = this.planID;
					} else {
						this.sellingPlansWrapper.classList.add('active', 'mandatory');
						this.sellingPlansWrapper.closest('[data-subsctiption-option').classList.add('open');
						return;
					}
				}

				const request = {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'X-Requested-With': 'XMLHttpRequest',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(product_data),
				};

				const response = await fetch(url, request);
				const result = await response.json();

				if (response.ok) {
					window.dispatchEvent(new CustomEvent('cart-update', { detail: { cartData: result } }));
				}
			}

			setOption(trigger) {
				if (this.options.length === 0) return;
				const activeOption = this.querySelector(
					`[data-subsctiption-option="${trigger.dataset.optionSelector}"]`,
				);
				if (!activeOption) return;
				if (activeOption.classList.contains('active')) return;

				this.options.forEach((option) => option.classList.remove('active'));
				activeOption.classList.add('active');
			}

			setSellingPlan(trigger) {
				this.dataset.planId = trigger.dataset?.planTrigger;
				this.sellingPlanTrigger.querySelector('[data-placeholder]').innerText = trigger.innerText;
				this.sellingPlansWrapper.classList.remove('active', 'mandatory');
			}

			toggleSellingPlans() {
				this.sellingPlansWrapper.classList.remove('mandatory');
				this.sellingPlansWrapper.classList.toggle('active');
				this.sellingPlansWrapper.closest('[data-subsctiption-option').classList.toggle('open');
			}

			increaseQuantity() {
				this.quantityInputs.forEach((input) => (input.value = Number(input.value) + 1));
				this.dataset.quantity = Number(this.dataset.quantity) + 1;
				this.decreaseQuantityButtons.forEach((button) => (button.disabled = false));
			}

			decreaseQuantity() {
				this.quantityInputs.forEach((input) => (input.value = Number(input.value) - 1));
				this.dataset.quantity = Number(this.dataset.quantity) - 1;
				if (Number(this.quantityInputs[0].value) === 1) {
					this.decreaseQuantityButtons.forEach((button) => (button.disabled = true));
				}
			}

			changeQuantity(event) {
				this.quantityInputs.forEach((input) => (input.value = event.target.value));
				this.dataset.quantity = event.target.value;
				if (Number(this.quantityInputs[0].value) === 1) {
					this.decreaseQuantityButtons.forEach((button) => (button.disabled = true));
				} else {
					this.decreaseQuantityButtons.forEach((button) => (button.disabled = false));
				}
			}
		},
	);
}
